import { render, staticRenderFns } from "./APP_URL.vue?vue&type=template&id=0c495853"
import script from "./APP_URL.vue?vue&type=script&lang=js"
export * from "./APP_URL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports